import { reportsNames } from 'services/report.service';
import registrationsReportsMapping from './registrationsReportsMapping';
import goodCallsCountReportsMapping from './goodCallsCountReportsMapping';
import goodCallsAnsweredCountReportMapping from './goodCallsAnsweredCountReportMapping';
import goodCallsAnswerSuccessRateReportMapping from './goodCallsAnswerSuccessRateReportMapping';
import spoofedCallsNotAnsweredSuccessRateReportMapping from './spoofedCallsNotAnsweredSuccessRateReportMapping';
import customersUnderAttackCountReportMapping from './customersUnderAttackCountReportMapping';
import devicesDistributionRatioReportMapping from './devicesDistributionRatioReportMapping';
import spoofedCallsCountWithCustomersReportMapping from './spoofedCallsCountWithCustomersReportMapping';
import ratingsDistributionReportMapping from './ratingsDistributionReportMapping';

export default {
	[reportsNames.registrations]: registrationsReportsMapping,
	[reportsNames.goodCallsCount]: goodCallsCountReportsMapping,
	[reportsNames.goodCallsAnsweredCount]: goodCallsAnsweredCountReportMapping,
	[reportsNames.goodCallsAnswerSuccessRate]: goodCallsAnswerSuccessRateReportMapping,
	[reportsNames.spoofedCallsNotAnsweredSuccessRate]: spoofedCallsNotAnsweredSuccessRateReportMapping,
	[reportsNames.customersUnderAttackCount]: customersUnderAttackCountReportMapping,
	[reportsNames.devicesDistributionRatio]: devicesDistributionRatioReportMapping,
	[reportsNames.spoofedCallsCountWithCustomers]: spoofedCallsCountWithCustomersReportMapping,
	[reportsNames.ratingsDistribution]: ratingsDistributionReportMapping,
};
